export default __webpack_public_path__ + "static/sales_2-79a9608b9a878ed837e056abfc7f5b71.png";